import graphQl, { grahqlQueryServiceV2 } from '@/services/graphQl';
import { Commit, ActionTree } from 'vuex';
import { State } from '@/store/modules/billing/billing.store';
import { AxiosResponse } from 'axios';
import {
  setTotalSizeList,
  setTotalActiveAgents,
} from '@/components/Billing&usage/billing.usage.constants';
import graphHelpers from '@/utils/graphHelper';
import { Context, Params } from '@/utils/types/global';
import axiosInstance from '@/services/api/http.service';
import getEnv from '@/utils/env';

const API_URL =
  getEnv('VUE_APP_AUTH_HOST') ||
  process.env.VUE_APP_AUTH_HOST ||
  'https://localhost:4000';

const actions: ActionTree<State, any> = {
  GET_TOTAL_SIZE_LIST(context: { commit: Commit; state: State }, params) {
    return graphQl
      .query('queryTotalSize')
      .params(params)
      .then((res: AxiosResponse<any>) => {
        if (!res.data.data) {
          console.error(res.data);
          throw Error(res.data);
        }
        if (res.data.data.getTotalSize.totalSizeList) {
          context.commit(
            setTotalSizeList,
            res.data.data.getTotalSize.totalSizeList,
          );
        } else {
          throw new Error(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  GET_TOTAL_ACTIVE_AGENTS_LIST(
    context: { commit: Commit; state: State },
    params,
  ) {
    return graphQl
      .query('queryTotalActiveAgents')
      .params(params)
      .then((res: AxiosResponse<any>) => {
        if (!res.data.data) {
          console.error(res.data);
          throw Error(res.data);
        }
        if (res.data.data.getActiveAgents.activeAgentsListPerCapability) {
          context.commit(
            setTotalActiveAgents,
            res.data.data.getActiveAgents.activeAgentsListPerCapability,
          );
        } else {
          throw new Error(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  GET_DISTRIBUTION_DATA(context: { commit: Commit; state: State }, params) {
    return grahqlQueryServiceV2
      .query('queryLicenseDistributionData')
      .params(params)
      .then((res: AxiosResponse<any>) => {
        if (!res.data) {
          console.error(res.data);
          throw Error(res.data);
        }
        if (res.data.data.getLicenseDistribution.data) {
          return res.data.data.getLicenseDistribution.data;
        } else {
          throw new Error(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  GET_LICENSE_USAGE_DATA(context: { commit: Commit; state: State }, params) {
    return grahqlQueryServiceV2
      .query('queryLicenseUsageData')
      .params(params)
      .then((res: AxiosResponse<any>) => {
        if (!res.data) {
          console.error(res.data);
          throw Error(res.data);
        }
        if (res.data.data.getLicenseUsageConsumption.data) {
          return res.data.data.getLicenseUsageConsumption.data;
        } else {
          throw new Error(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  GET_CAPACITY_USED_DATA(context: { commit: Commit; state: State }, params) {
    const data = {
      total: {
        dataset: {
          total_size: 1000000,
          total_used: 123456,
        },
        session: {
          total_size: 1000000,
          total_used: 234567,
        },
        endpoint: {
          total_size: 1000000,
          total_used: 345678,
        },
      },
    };

    return data;
    return grahqlQueryServiceV2
      .query('queryLicenseUsedCapacityData')
      .params(params)
      .then((res: AxiosResponse<any>) => {
        if (!res.data) {
          console.error(res.data);
          throw Error(res.data);
        }
        if (res.data.data.licenseUsageConsumption.data) {
          return res.data.data.licenseUsageConsumption.data;
        } else {
          throw new Error(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  GET_TOP_LICENSE_USAGE(context: Context, params: Params) {
    return grahqlQueryServiceV2
      .query('queryTopLicenseApplication')
      .params(params)
      .then((res: AxiosResponse<any>) => {
        if (res.data.data.getCapabilityUsageDistribution.data) {
          return res.data.data.getCapabilityUsageDistribution.data;
        } else {
          throw new Error(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  async GET_USAGE_BY_APPLICATIONS(context: Context, params: Params) {
    return grahqlQueryServiceV2
      .query('queryLicenseUageForServices')
      .params(params)
      .then((res: AxiosResponse<any>) => {
        if (res.data.data.getLicenseUsageForServices.data) {
          return res.data.data.getLicenseUsageForServices.data;
        } else {
          throw new Error(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  GET_CAPABILITY_LICENSE_USAGE(context: Context, params: any) {
    return grahqlQueryServiceV2
      .query('queryCapabilityLicenseUsage')
      .params(params)
      .then((res: AxiosResponse<any>) => {
        return res.data.data;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  async getLicense(
    context: { commit: Commit },
    params: {
      tenantId: string;
    },
  ) {
    try {
      const response = await new axiosInstance({
        auth: true,
      }).post(`${API_URL}/license/get-upload-license`, params);

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async getLicenseOverview(
    context: { commit: Commit },
    params: {
      tenantId: string;
    },
  ) {
    try {
      const response = await new axiosInstance({
        auth: true,
      }).post(`${API_URL}/license/license-overview`, params);

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async deactivateLicense(
    context: { commit: Commit },
    params: {
      tenantId: string;
    },
  ) {
    try {
      const response = await new axiosInstance({
        auth: true,
      }).post(`${API_URL}/license/deactivate-upload-license`, params);

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async getLicenseExpiry(
    context: { commit: Commit },
    params: {
      tenantId: string;
    },
  ) {
    try {
      return grahqlQueryServiceV2
        .query('queryLicenseExpiry')
        .params(params)
        .then((res: AxiosResponse<any>) => {
          return res.data.data.getLicenseDistribution.data;
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  },
};
export default actions;
